<div class="pb-5 px-md-5 mt-md-5">
  <h2 class="text-info mb-4">Voici la liste des professionnels engagés avec Opale autour de vous :</h2>
  <div class="row g-4">
    <div class="col-12 col-lg-3" *ngFor="let pro of pros">
      <div class="card-pro">
        <img [src]="pro.image | proImage" class="pro-avatar" [alt]="pro.lastname" *ngIf="pro.image">
        <div class="pro-avatar-placeholder" *ngIf="!pro.image">
          <span class="material-icons">person</span>
        </div>
        <p class="pro-name">{{pro.firstname}} {{pro.lastname}}</p>
        <p class="pro-city">
          <span class="material-icons">location_on</span>
          {{ pro.city }}
        </p>
        <span class="modal-badge modal-badge-visio mb-2" *ngIf="pro.visio">
          <span class="material-icons">videocam</span>
          Consultation vidéo
        </span>
        <button class="btn btn-info text-white fw-semibold w-100 mt-auto pt-2" style="border-radius: 10px" (click)="openModalPro(pro)">Plus d'informations</button>
      </div>
    </div>
    <div class="col-12" *ngIf="!(pros?.length)">
      <p class="text-muted fs-5">Nous enrichissons actuellement la liste des professionnels engagés autour de vous. Parlez en autour de vous pour nous aider à référencer les professionnels engagés.</p>
    </div>
  </div>
</div>
